<init-comp-api (tenentIdCapture)="isTenantLoaded=true"></init-comp-api>
<div *ngIf="isTenantLoaded">
<header>
  <app-header></app-header>
</header>
<main>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</main>
<footer>
  <app-footer></app-footer>
</footer>
</div>